export const SORT_SEPARATOR = '_'

export const SORT_DIR = {
  ASC: 'asc',
  DESC: 'desc',
}
